import React from 'react';
import LinkCell3 from "./LinkCell3/LinkCell3";
import {useParams} from 'react-router-dom'

function ToPatients(props) {
    const {orgId, orgName} = useParams()
    return (
        <LinkCell3
            linkRoute={process.env.REACT_APP_URL_PREFIX + `/counterAgents/allOrgList/orgHistory/${orgId}/${orgName}/history/${props.idArr[0]}/${props.cellContent[props.cellData.show]}`}
            linkTitle={props.cellContent[props.cellData.show]} editClick={_ => props.cellData.onClick(props.idArr[1])}/>
    );
}

export default ToPatients;